import React, { useState, useEffect } from 'react';
import './Challenge.css';
import { CSVLink } from 'react-csv';
import { FiChevronDown, FiRefreshCw } from 'react-icons/fi';
const LoginReport = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const token = localStorage.getItem('auth-token');
  const [startDateFilter, setStartDateFilter] = useState(() => {
    const date = new Date();
    return date.toISOString().split('T')[0];
  });
  const [endDateFilter] = useState(() => {
    const date = new Date();
    return date.toISOString().split('T')[0];
  });
  const [selectedAcademy] = useState("All");
  const [LoginReport, setLoginReport] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');


  const apiUrl = process.env.REACT_APP_API_REPORTS_LAST_ACTIVE;
  const fetchLoginReport = async () => {
    setLoading(true);
    setError('');

    const headers = {
      "Content-Type": "application/json",
      'Authorization': `Bearer ${token}`,
    };

    try {
      const url = new URL(apiUrl);
      url.searchParams.append("date_from", startDateFilter);

      const response = await fetch(url, {
        method: "GET",
        headers: headers,
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const data = await response.json();

      if (data.success) {
        const transformedData = data.data.loginUsers.map((user) => ({
          parentName: user?.name,
          mobileNumber: user?.mobileNumber,
          academy: user?.academyNames || '-',
          playerName: user?.playerName || "-",
          lastActive: user?.lastActiveAt ? new Date(user.lastActiveAt).toLocaleDateString() : "-",
          lastLogin: user?.lastLoginAt ? new Date(user.lastLoginAt).toLocaleDateString() : "-",
          oneSignalDeviceId: user?.oneSignalDeviceId || "-",
        }));

        setLoginReport(transformedData);
      } else {
        setError('Failed to load data: ' + data.success_message);
      }
    } catch (error) {
      setError('Error fetching data: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLoginReport();
  }, [startDateFilter, endDateFilter]);

  const headers = [
    { label: "Parent Name", key: "parentName" },
    { label: "Mobile Number", key: "mobileNumber" },
    { label: "Academy", key: "academy" },
    { label: "Player Name", key: "playerName" },
    { label: "Last Active", key: "lastActive" },
    { label: "Last Login", key: "lastLogin" },
    { label: "OneSignal Device ID", key: "oneSignalDeviceId" },
  ];

  const [sortOrder, setSortOrder] = useState({ column: '', direction: 'asc' });
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setrowsPerPage] = useState(10);

  const handleItemsPerPageChange = (event) => {
    setrowsPerPage(Number(event.target.value));
    setCurrentPage(1);
  };

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
    setCurrentPage(1);
  };

  const handleStartDateFilterChange = (event) => {
    setStartDateFilter(event.target.value);
    setCurrentPage(1);
  };

  const filteredLoginReport = LoginReport.filter((row) =>
    Object.values(row)
      .join(' ')
      .toLowerCase()
      .includes(searchTerm.toLowerCase()) &&
    (selectedAcademy === "All" || row.academy.includes(selectedAcademy))
  );

  const handleSort = (column) => {
    const isAsc = sortOrder.column === column && sortOrder.direction === 'asc';
    const direction = isAsc ? 'desc' : 'asc';

    const sortedData = [...LoginReport].sort((a, b) => {
      if (a[column] < b[column]) return direction === 'asc' ? -1 : 1;
      if (a[column] > b[column]) return direction === 'asc' ? 1 : -1;
      return 0;
    });

    setLoginReport(sortedData);
    setSortOrder({ column, direction });
  };

  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = filteredLoginReport.slice(indexOfFirstRow, indexOfLastRow);
  const totalPages = Math.ceil(filteredLoginReport.length / rowsPerPage);

  const handlePageClick = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage((prevPage) => prevPage + 1);
  };

  const handlePrevPage = () => {
    if (currentPage > 1) setCurrentPage((prevPage) => prevPage - 1);
  };

  const generatePageNumbers = () => {
    const pages = [];
    const totalPagesToShow = 5;

    if (totalPages <= totalPagesToShow) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      pages.push(1);
      if (currentPage > 3) pages.push('...');
      for (let i = Math.max(2, currentPage - 1); i <= Math.min(totalPages - 1, currentPage + 1); i++) {
        pages.push(i);
      }
      if (currentPage < totalPages - 2) pages.push('...');
      pages.push(totalPages);
    }
    return pages;
  };

  const renderPagination = () => {
    return generatePageNumbers().map((page, index) =>
      typeof page === 'number' ? (
        <button
          key={index}
          className={`page-number ${currentPage === page ? 'active' : ''}`}
          onClick={() => handlePageClick(page)}
        >
          {page}
        </button>
      ) : (
        <span key={index} className="pagination-dots">
          {page}
        </span>
      )
    );
  };

  const totalEntries = filteredLoginReport.length;
  const indexOfFirstEntry = totalEntries > 0 ? (currentPage - 1) * rowsPerPage + 1 : 0;
  const indexOfLastEntry = totalEntries > 0 ? Math.min(currentPage * rowsPerPage, totalEntries) : 0;

  return (
    <div className="enrollment-container">
      <div className="sales-filters-login">

        <div className="floating-select">
          <input
            type="date"
            className={`sales-filter-academy has-value`}
            value={startDateFilter}
            onChange={handleStartDateFilterChange}
            onClick={(e) => e.target.showPicker()}
            max={new Date().toISOString().split('T')[0]}
          />
          <label htmlFor="startDateFilter">Start Date</label>
        </div>

        {/* <div className="floating-select">
          <input
            type="date"
            className={`sales-filter-academy has-value`}
            value={endDateFilter}
            onChange={handleEndDateFilterChange}
            onClick={(e) => e.target.showPicker()}
          />
         <label htmlFor="endDateFilter">End Date</label>
        </div> */}

      </div>
      <div className="search-bar">
        <div className="input-container">
          <input
            type="text"
            id="searchInput"
            placeholder=""
            className={`search-input ${searchTerm ? "has-value" : ""}`}
            value={searchTerm}
            onChange={handleSearchChange}
          />
          <label htmlFor="searchInput" className="floating-label">
            🔍 Search
          </label>
        </div>

        <CSVLink
          data={filteredLoginReport.map(({ mobileNumber, ...rest }) => rest)}
          headers={headers.filter(header => header.key !== 'mobileNumber')}
          filename="LoginReport.csv"
          className="btn btn-primary no-decoration"
        >
          <button className="csv_button" type="button" >
            <span
              className="button__text"

            >
              Export CSV
            </span>
            <span className="button__icon">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 35 35" className="svg">
                <path d="M17.5,22.131a1.249,1.249,0,0,1-1.25-1.25V2.187a1.25,1.25,0,0,1,2.5,0V20.881A1.25,1.25,0,0,1,17.5,22.131Z"></path>
                <path d="M17.5,22.693a3.189,3.189,0,0,1-2.262-.936L8.487,15.006a1.249,1.249,0,0,1,1.767-1.767l6.751,6.751a.7.7,0,0,0,.99,0l6.751-6.751a1.25,1.25,0,0,1,1.768,1.767l-6.752,6.751A3.191,3.191,0,0,1,17.5,22.693Z"></path>
                <path d="M31.436,34.063H3.564A3.318,3.318,0,0,1,.25,30.749V22.011a1.25,1.25,0,0,1,2.5,0v8.738a.815.815,0,0,0,.814.814H31.436a.815.815,0,0,0,.814-.814V22.011a1.25,1.25,0,1,1,2.5,0v8.738A3.318,3.318,0,0,1,31.436,34.063Z"></path>
              </svg>
            </span>
          </button>
        </CSVLink>

      </div>

      <div className="items-and-dues">
        <select className="items-per-page-select" value={rowsPerPage} onChange={handleItemsPerPageChange}>
          <option value={10}>10 items per page</option>
          <option value={50}>50 items per page</option>
          <option value={75}>75 items per page</option>
          <option value={100}>100 items per page</option>
        </select>
        <div className="pagination-selector">
          <div className="button-group">
            <div className="group-label">Items per page:</div>
            <div className="button-options">
              {[10, 50, 75, 100].map((option) => (
                <button
                  key={option}
                  onClick={() =>
                    handleItemsPerPageChange({ target: { value: option } })
                  }
                  className={`page-button ${rowsPerPage === option ? 'active' : ''}`}
                >
                  <span className="button-text">{option}</span>
                </button>
              ))}
            </div>
          </div>
        </div>
        <button className="tt-action-btn" onClick={fetchLoginReport}>
          <FiRefreshCw className={`refresh-icon ${loading ? 'spin' : ''}`} />
          Refresh
        </button>

      </div>

      {loading && (
        <div className="premium-loader">
          <div className="progress-track">
            <div className="progress-bar"></div>
          </div>
          <div className="status-text">
            <span>L</span>
            <span>O</span>
            <span>A</span>
            <span>D</span>
            <span>I</span>
            <span>N</span>
            <span>G</span>
          </div>
        </div>
      )}
      {error && <div className="error-message">{error}</div>}
      {!loading && !error && filteredLoginReport.length === 0 && (
        <div className="error-message">No data available</div>
      )}


      <div className="tt-table-container">
        <table className="tt-table">
          <thead>
            <tr className="challenges-header-row">
              {headers.map(({ key, label }) => (
                <th
                  key={key}
                  className="challenges-column"
                  onClick={() => handleSort(key)}
                >
                  <div className="th-content">
                    <span>{label}</span>
                    <FiChevronDown
                      className={`sort-icon ${sortOrder.column === key ? 'active' : ''} 
              ${sortOrder.column === key && sortOrder.direction === 'desc' ? 'desc' : ''}`}
                    />
                  </div>
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {currentRows.map((LoginReport) => (
              <tr key={LoginReport} className="challenges-row">
                <td className="challenges-cell">{LoginReport.parentName}</td>
                <td className="challenges-cell">{LoginReport.mobileNumber}</td>
                <td className="challenges-cell">{LoginReport.academy}</td>
                <td className="challenges-cell">{LoginReport.playerName}</td>
                <td className="challenges-cell">{LoginReport.lastActive}</td>
                <td className="challenges-cell">{LoginReport.lastLogin}</td>
                <td className="challenges-cell">{LoginReport.oneSignalDeviceId}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="pagination">
        <div className="showing-entries">
          Showing {indexOfFirstEntry} to {indexOfLastEntry} of {totalEntries} entries
        </div>
        <button
          className="prev-button"
          onClick={handlePrevPage}
          disabled={currentPage === 1}
        >
          Previous
        </button>
        {renderPagination()}
        <button
          className="next-button"
          onClick={handleNextPage}
          disabled={currentPage === totalPages}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default LoginReport;